import { InjectionToken } from '@angular/core';

export const MODAL_CONTENT_CONTEXT = new InjectionToken('Context data pass to injector modal content');
